import { gql } from "@apollo/client";

export const MUTATION_CREATE_RESOURCE_ASSET_DOWNLOAD_HISTORY = gql`
  mutation createResourceAssetDownloadHistory(
    $data: ResourceAssetDownloadHistoryInput!
  ) {
    createResourceAssetDownloadHistory(data: $data) {
      documentId
      downloadedAt
      version
    }
  }
`;
